import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PulseParticipationTrendComponent } from './pulse-participation-trend.component';
import {HighchartsChartModule} from "highcharts-angular";
import {AlertBannerModule} from "../../lib/alert-banner";



@NgModule({
  declarations: [PulseParticipationTrendComponent],
  imports: [
    CommonModule,
    HighchartsChartModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [PulseParticipationTrendComponent]
})
export class PulseParticipationTrendModule { }
